import { upperFirst } from "lodash";

export function useString() {
    function ucwords(text: string) {
        return text.replace(/\w+/g, upperFirst);
    }

    return {
        ucwords,
    };
}
